import { ReactNode } from "react";
import Modal from "react-bootstrap/Modal";
import CustomButton from "../button/CustomButton";
import { BsArrowLeft } from "react-icons/bs";

interface ModalProps {
  children: ReactNode;
  customFooter?: ReactNode;
  size: "sm" | "lg" | "xl";
  tipoModal: "MODAL_LATERAL" | "MODAL_CENTRAL" | "MODAL_LATERAL_METADE";
  showModal: boolean;
  renderHeaderModal?: boolean;
  titulo?: string;
  fecharModalAoClicarFora?: boolean;
  bodyClassName?: string;
  onCloseModal: () => void;
  onOpenModal?: () => void;
  scrollable?: boolean;
  customHeader?: ReactNode;
  hideCloseButton?: boolean;
  centered?: boolean;
  usarSize?: boolean;
  dialogClassName?: string;
}

const CustomModal: React.FC<ModalProps> = (props) => {
  let sizeClassName = `${props.size}-modal`;

  const usarSize = props.usarSize ?? true;

  const renderModal = () => {
    if (props.tipoModal === "MODAL_LATERAL") {
      return (
        <Modal
          backdrop={props.fecharModalAoClicarFora ? true : "static"}
          dialogClassName={`right-modal-dialog ${sizeClassName}`}
          contentClassName={`right-modal-content ${sizeClassName}`}
          animation
          scrollable={props.scrollable}
          show={props.showModal}
          onShow={() => (props.onOpenModal ? props.onCloseModal() : undefined)}
          onHide={() => props.onCloseModal()}
          centered={props.centered}
        >
          {renderHeaderModal()}
          {renderBodyModal()}
          {renderFooterModal()}
        </Modal>
      );
    } else if (props.tipoModal === "MODAL_LATERAL_METADE") {
      return (
        <Modal
          dialogClassName="modal-lateral-metade"
          contentClassName="modal-lateral-metade"
          backdrop={props.fecharModalAoClicarFora ? true : "static"}
          animation
          scrollable={props.scrollable}
          show={props.showModal}
          onShow={() => (props.onOpenModal ? props.onCloseModal() : undefined)}
          onHide={() => props.onCloseModal()}
          centered={props.centered}
        >
          {renderHeaderModal()}
          {renderBodyModal()}
          {renderFooterModal()}
        </Modal>
      );
    }

    return (
      <Modal
        backdrop={props.fecharModalAoClicarFora ? true : "static"}
        animation
        scrollable={props.scrollable}
        size={usarSize ? props.size : undefined}
        dialogClassName={props.dialogClassName}
        show={props.showModal}
        onShow={() => (props.onOpenModal ? props.onCloseModal() : undefined)}
        onHide={() => props.onCloseModal()}
        centered={props.centered}
      >
        {renderHeaderModal()}
        {renderBodyModal()}
        {renderFooterModal()}
      </Modal>
    );
  };

  const renderHeaderModal = () => {
    if (props.renderHeaderModal !== false) {
      if (props.customHeader) {
        return props.customHeader;
      }
      return (
        <>
          {!props.hideCloseButton ? (
            <Modal.Header className={"header-modal-gc"} closeButton closeVariant="white">
              <Modal.Title>{props.titulo}</Modal.Title>
            </Modal.Header>
          ) : (
            <Modal.Header className={"header-modal-gc"}>
              <Modal.Title>{props.titulo}</Modal.Title>
            </Modal.Header>
          )}
        </>
      );
    }
  };

  const renderBodyModal = () => {
    return <Modal.Body className={props.bodyClassName}>{props.children}</Modal.Body>;
  };

  const renderFooterModal = () => {
    if (props.customFooter === null) return null;
    if (props.customFooter) return <Modal.Footer>{props.customFooter}</Modal.Footer>;

    return (
      <Modal.Footer>
        <CustomButton
          id="botao-voltar-modal"
          label="Voltar"
          variant="warning"
          leftIcon={BsArrowLeft}
          onClick={() => props.onCloseModal()}
        />
      </Modal.Footer>
    );
  };

  return <>{renderModal()}</>;
};

export default CustomModal;
